import styled from 'styled-components';

export const InputBox = styled.div`
    display: flex;
    align-items: center;

    > input {
        flex: 1;
    }
`;